// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2kDCI","inner":"Footer_inner__3m7dI","nextIcon":"Footer_nextIcon__V69Z6","innerLeft":"Footer_innerLeft__3q1Qy"};